import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {EmailComponentComponent} from './EmailComponent.component';

const routes: Routes = [
    {
        path: '',
        component: EmailComponentComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EmailComponentRoutingModule {}
